import React, { useCallback } from 'react';

export function useDialog() {
    const [visible, setVisible] = React.useState<boolean>(false);

    const handleOpen = useCallback(() => {
        setVisible(true);
    }, []);

    const handleClose = useCallback(() => {
        setVisible(false);
    }, []);

    const handleToggle = useCallback(() => {
        setVisible(!visible);
    }, [visible]);

    return {
        visible,
        handleOpen,
        handleClose,
        handleToggle,
    };
}

export default useDialog;
